<div class="form-alerts">
    <div class="form-alerts__msgs">
        <span class="form-alerts__msgs-def" v-for="alert in messages" :class="'form-alerts__msgs-' + alert.type">
            <p>{{  $t(alert.content) }}</p>
            <i @click="removeMessage(alert.content)"></i>
        </span>
    </div>
</div>
